import { useState } from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import clsx from 'clsx'
import { XSquare, RotateCcw } from 'react-feather'

import { Modal, Button } from '@pepper/ui'

import noop from '@pepper/utils/src/function/noop'
import { updateAssignmentContent } from '@pepper/utils/src/api/assignments/assignments'

import styles from './_.module.css'

type Props = {
  refetch: {
    threads: () => void
    assignmentDetails: () => void
    feedback: () => void
  }
  assignmentId: string
  projectCategory: ProjectCategory
}

const ReworkConfirmationModal = NiceModal.create<Props>(
  ({ assignmentId, projectCategory, refetch }) => {
    const modal = useModal()
    const declineAssignmentModal = useModal('decline-assignment-submission')
    const [type, setType] = useState('')

    const getType = (type: string) => {
      if (type === 'rework') {
        setType(type)
      }
      if (type === 'reject') {
        setType(type)
      }
    }
    return (
      <Modal
        title="Unsatisfied with the content"
        onOk={() => modal.hide()}
        visible={modal.visible}
        onCancel={() => modal.hide()}
        afterClose={() => modal.remove()}
        closable={true}
        className={styles.modalContainer}
        footer={
          <>
            <Button
              onClick={() => {
                modal.hide()
              }}
              className={styles.ModalCancelButton}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                modal.hide()
                declineAssignmentModal.show({
                  assignment: { id: assignmentId },
                  handleOnOkClick: refetch?.assignmentDetails,
                  handleOnCancelClick: noop,
                  type,
                  subType: type === 'rework' ? 'revamp' : 'reject',
                  projectCategory,
                  defaultComment:
                    'Please rework and revamp the entire content from scratch.',
                })
              }}
              disabled={type === '' ? true : false}
              className={styles.ModalProceedButton}
            >
              Proceed
            </Button>
          </>
        }
      >
        <div className={styles.subHeading}>
          We’re sorry about this. How can we help?
        </div>
        <div style={{ display: 'flex', gap: '2rem', marginLeft: '4px' }}>
          {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
          <label
            style={{ maxWidth: '200px', wordWrap: 'break-word' }}
            className={clsx(styles.ctaWrapper, {
              [styles.colourBlockActive]: type === 'rework',
            })}
          >
            <input
              value="rework"
              className={styles.visiblityHidden}
              type="checkbox"
              onClick={() => {
                getType('rework')
                updateAssignmentContent(assignmentId)
              }}
              checked={type === 'rework'}
            ></input>
            <div className={styles.card}>
              <div className={styles.ctaInside}>
                <RotateCcw className={styles.revampIcon} />
                <span className={styles.InfoTitle}>Revamp the content</span>
                <span className={styles.subInfo}>
                  {`We'll redo the content from scratch. This might take slightly longer time.`}
                </span>
              </div>
            </div>
          </label>
          <label
            style={{ maxWidth: '200px', wordWrap: 'break-word' }}
            className={clsx(styles.ctaWrapper, {
              [styles.colourBlockActive]: type === 'reject',
            })}
          >
            <input
              value="reject"
              className={styles.visiblityHidden}
              checked={type === 'reject'}
              onClick={() => getType('reject')}
              type="checkbox"
            ></input>
            <div className={styles.card}></div>
            <div className={styles.ctaInside}>
              <XSquare className={styles.rejectIcon} />
              <span className={styles.InfoTitle}> Reject Assignment </span>
              <span className={styles.subInfo}>
                {`We'll cancel the assignment request completely and not work on it further.`}
              </span>
            </div>
          </label>
        </div>
      </Modal>
    )
  }
)

export default ReworkConfirmationModal
